export default function Starships() {
  return <div>N/A</div>;
}
